module.exports = __webpack_public_path__ + "static/media/IMG_6347.21f0844a.JPG";